import React from 'react';

import {
  QButton,
  QEmptyState,
  QEmptyStateButtonGroup,
  QEmptyStatePrimaryButton,
  QHeading,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

const SupplierUpSellView: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <QHeading size="lg">{t('supplierList.heading')}</QHeading>
      <div data-cy="ga-upsell">
        <QEmptyState title={t('upSellViews.upgradeAccess.title')} subtitle={t('upSellViews.upgradeAccess.subtitle')}>
          <QEmptyStateButtonGroup>
            <QEmptyStatePrimaryButton>
              <QButton
                onClick={() =>
                  (window.location.href = 'https://docs.qualio.com/en/articles/6010307-suppliers-overview')
                }
              >
                {t('upSellViews.upgradeAccess.button')}
              </QButton>
            </QEmptyStatePrimaryButton>
          </QEmptyStateButtonGroup>
        </QEmptyState>
      </div>
    </>
  );
};

export default SupplierUpSellView;
